<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3 sidebar-org bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageStrategies") }}</h4>
          <button @click="openModal(false, '', 'strategy', 'add')" type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#strategyEditModal"> + {{ $t("general.add") }} </button>
        </div>

        <!-- Time-Filter -->
        <div class="row mt-4">
          <div class="col-6">
            <button class="btn btn-sm dropdown-toggle bg-white text-start" style="width: 200px" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span>{{ formatDate(new Date(filterValidFrom)) }} &nbsp;-&nbsp; {{ formatDate(new Date(filterValidTo)) }}</span>
            </button>
            <div class="dropdown-menu border-secondary p-3">
              <div class="row">
                <div class="col-12">
                  <button @click="filterStrategies(new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10))" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ $t("general.today") }}</button>
                  <button @click="filterStrategies((new Date().getFullYear() + 1).toString() + '-01-01', (new Date().getFullYear() + 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() + 1 }}</button>
                  <button @click="filterStrategies(new Date().getFullYear().toString() + '-01-01', new Date().getFullYear().toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() }}</button>
                  <button @click="filterStrategies((new Date().getFullYear() - 1).toString() + '-01-01', (new Date().getFullYear() - 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() - 1 }}</button>
                </div>
              </div>
              <hr class="dropdown-divider">
              <div class="row">
                <div class="col-6">
                  <label for="filterValidFrom" class="form-label">{{ $t("views.kpi.periods.from") }}:</label>
                  <input v-model="filterValidFrom" type="date" class="form-control form-control-sm" id="filterValidFrom">
                </div>
                <div class="col-6">
                  <label for="filterValidTo" class="form-label">{{ $t("views.kpi.periods.to") }}:</label>
                  <input v-model="filterValidTo" type="date" class="form-control form-control-sm" id="filterValidTo">
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <button @click="filterStrategies(filterValidFrom, filterValidTo)" class="btn btn-sm btn-outline-primary mt-3" type="button">{{ $t("views.kpi.periods.filter") }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search & Slider -->
        <div class="row mt-1">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Search -->
              <div class="me-3" style="width: 200px"> <input v-model="searchText" type="text" :placeholder="$t('general.placeholderSearch')" class="form-control form-control-sm mt-0" />
              </div>
              <!-- Level-Slider from 2 to maxTreeLevel -->
              <div class="d-flex flex-column align-items-start mb-2">
                <div class="fs-08 text-muted mb-1"> {{ $t('general.treeViewLevels') }}: {{ autoOpenDepth }} </div>
                <div class="d-flex align-items-center gap-2">
                  <input type="range" class="form-range foc-range" min="2" :max="maxTreeDepth" step="1" v-model="autoOpenDepth" :key="sliderKey">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <StrategyTree v-if="'nodes' in strategies && strategies.nodes.length" :node="strategies" :depth="0"  mode="manage" :searchText="searchText" :autoOpenDepth="autoOpenDepth" class="mt-2"></StrategyTree>
          </div>
        </div>
      </div>

      <div class="col-9 px-5 py-3">
        <div v-if="Object.keys(selectedStrategy).length" class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <button v-if="selectedStrategy.write" @click="openModal(selectedStrategy.id, '', 'strategy', 'update')" type="button" class="btn btn-sm btn-outline-dark" data-bs-toggle="modal" data-bs-target="#strategyEditModal">&bull; {{ $t("general.update") }}</button>
              </div>
            </div>

            <!-- Name & Heading Data -->
            <div class="row mt-3">
              <div class="col">

                <div class="h4">{{ selectedStrategy.name }}</div>

                <!-- Folder description -->
                <div v-if="selectedStrategy.folder">
                  <div v-if="selectedStrategy.description" class="mt-3">
                    <QuillContent :content="this.selectedStrategyDescriptionFull" />
                  </div>
                </div>

                <ul v-if="!selectedStrategy.folder" class="list-group list-group-horizontal-md foc-list-header">
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.kpi.edit.responsible") }}:</div>
                    <div>{{ selectedStrategy.responsible.name }}</div>
                  </li>
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.kpi.structure.validityPeriod") }}:</div>
                      <div>
                        <span v-if="selectedStrategy.validFrom"> {{ formatDate(new Date(selectedStrategy.validFrom)) }} - {{ formatDate(new Date(selectedStrategy.validTo)) }} </span>
                        <span v-else> {{ $t("views.strategy.structure.infinite") }} </span>
                      </div>
                  </li>
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.objective.edit.orgUnit") }}:</div>
                    <div>{{ selectedStrategy.orgUnitName }}</div>
                  </li>
                </ul>

              </div>
            </div>
            <div v-if="!selectedStrategy.folder" class="row mt-3">
              <div class="row mt-3">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header fw-bold">{{ $t("views.strategy.detail.headingCard") }}</div>
                    <div class="card-body">
                      <ul class="nav nav-tabs border-bottom" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link text-dark active" id="definition-tab" data-bs-toggle="tab" data-bs-target="#definition" type="button" role="tab" aria-controls="definition" aria-selected="false">{{ $t("views.strategy.detail.tabDefinition") }}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link text-dark" id="reviews-tab" data-bs-toggle="tab" data-bs-target="#reviews" type="button" role="tab" aria-controls="reviews" aria-selected="false">{{ $t("views.strategy.detail.tabReviews") }} <span v-if="selectedStrategy.reviews.length" class="badge bg-primary">{{ selectedStrategy.reviews.length}}</span></button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link text-dark" id="measures-tab" data-bs-toggle="tab" data-bs-target="#measures" type="button" role="tab" aria-controls="measures" aria-selected="false">{{ $t("views.strategy.detail.tabMeasures") }} <span v-if="selectedStrategy.measures.length" class="badge bg-primary">{{ selectedStrategy.measures.length}}</span></button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link text-dark" id="relationsships-tab" data-bs-toggle="tab" data-bs-target="#relationships" type="button" role="tab" aria-controls="relationships" aria-selected="false">{{ $t("views.relationships.tabRelationships") }} <span v-if="selectedStrategy.relationships.length" class="badge bg-primary">{{ selectedStrategy.relationships.length}}</span></button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link text-dark" id="trials-tab" data-bs-toggle="tab" data-bs-target="#trials" type="button" role="tab" aria-controls="trials" aria-selected="false">{{ $t("views.strategy.detail.tabTrials") }} <span v-if="selectedStrategy.trials.length" class="badge bg-primary">{{ selectedStrategy.trials.length}}</span></button>
                        </li>
                      </ul>
                      <div class="tab-content mt-2">
                        <div class="tab-pane fade show active" id="definition" role="tabpanel">
                          <div v-if="selectedStrategy.description" class="mt-3">
                            <QuillContent :content="this.selectedStrategyDescriptionFull" />
                          </div>
                          <div v-else class="mt-3 h6">{{ $t("views.strategy.detail.noDescription") }}</div>
                        </div>
                        <div class="tab-pane fade" id="reviews" role="tabpanel">
                          <div v-if="selectedStrategy.write" class="row my-3">
                            <div class="col">
                              <button @click="openModal(false, '', 'review', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#strategyEditModal">+ {{ $t("general.add") }}</button>
                            </div>
                          </div>
                          <div v-if="selectedStrategy.reviews.length">
                            <table class="table">
                              <thead>
                                <tr class="border-dark">
                                  <th scope="col">{{ $t("views.strategy.detail.reviewDate") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.reviewAssessment") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.reviewConversion") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.reviewPrediction") }}</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="review in selectedStrategy.reviews" :key="'review' + review.id">
                                  <th scope="row" class="fw-normal">{{ formatDate(new Date(review.date)) }}</th>
                                  <td v-html="review.assessment" class="w-50"></td>
                                  <td>
                                    <div class="progress position-relative border bg-dark border-dark w-50">
                                      <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * review.conversion }}%</span>
                                      <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * review.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * review.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                  </td>
                                  <td>
                                    <span class="badge fw-normal" :class="review.prediction === 'Y' ? 'text-bg-success' : review.prediction === 'D' ? 'text-bg-warning' : 'text-bg-danger'">
                                      {{ $t("views.strategy.detail.review.prediction." + review.prediction.toLowerCase()) }}
                                    </span>
                                  </td>
                                  <td v-if="selectedStrategy.write" class="text-end">
                                    <div class="dropdown">
                                      <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                        <svg class="bi" width="28" height="28" fill="currentColor">
                                          <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                        </svg>
                                      </a>
                                      <ul class="dropdown-menu">
                                        <li><a @click="openModal(review.id, review.assessment, 'review', 'update')" class="dropdown-item" href="#strategyEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                      <li><a @click="openModal(review.id, review.assessment, 'review', 'delete')" class="dropdown-item" href="#strategyDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-else class="mt-3 h6">{{ $t("views.strategy.detail.noReviews") }}</div>
                        </div>
                        <div class="tab-pane fade" id="measures" role="tabpanel">
                          <div v-if="selectedStrategy.write" class="row my-3">
                            <div class="col">
                              <button @click="openModal(false, '', 'measure', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#strategyEditModal">+ {{ $t("general.add") }}</button>
                            </div>
                          </div>
                          <div v-if="selectedStrategy.measures.length">
                            <table class="table">
                              <thead>
                                <tr class="border-dark">
                                  <th scope="col">{{ $t("views.strategy.detail.measureTitle") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.measureResponsible") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.measureConversion") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.measureValidFrom") }}</th>
                                  <th scope="col">{{ $t("views.strategy.detail.measureValidTo") }}</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="measure in selectedStrategy.measures" :key="'measure' + measure.id">
                                  <th class="fw-normal" v-tooltip.bottom="{ key: 'tooltip.preview', params: { html: measure.measure } }">{{ measure.title }}</th>
                                  <td>{{ measure.responsible.name }}</td>
                                  <td>
                                    <div class="progress position-relative border bg-dark border-dark w-50">
                                      <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * measure.conversion }}%</span>
                                      <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * measure.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * measure.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                  </td>
                                  <td>{{ formatDate(new Date(measure.validFrom)) }}</td>
                                  <td :class="new Date(measure.validTo) < new Date() ? 'text-danger' : 'text-dark'">{{ formatDate(new Date(measure.validTo)) }}</td>
                                  <td v-if="selectedStrategy.write" class="text-end">
                                    <div class="dropdown">
                                      <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                        <svg class="bi" width="28" height="28" fill="currentColor">
                                          <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                        </svg>
                                      </a>
                                      <ul class="dropdown-menu">
                                        <li><a @click="openModal(measure.id, measure.title, 'measure', 'update')" class="dropdown-item" href="#strategyEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                        <li><a @click="openModal(measure.id, measure.title, 'measure', 'delete')" class="dropdown-item" href="#strategyDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-else class="mt-3 h6">{{ $t("views.strategy.detail.noMeasures") }}</div>
                        </div>
                        <div class="tab-pane fade" id="relationships" role="tabpanel">
                          <div v-if="selectedStrategy.write" class="row my-3">
                            <div class="col">
                              <button @click="openModal(false, '', 'relationship', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#strategyEditModal">+ {{ $t("general.add") }}</button>
                            </div>
                          </div>
                          <div v-if="selectedStrategy.relationships.length">
                            <table class="table">
                                <thead>
                                  <tr class="border-dark">
                                  <th scope="col">{{ $t("views.relationships.headerLabel") }}</th>
                                  <th scope="col">{{ $t("views.relationships.headerObject") }}</th>
                                  <th scope="col">{{ $t("views.relationships.headerValidFrom") }}</th>
                                  <th scope="col">{{ $t("views.relationships.headerValidTo") }}</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="relationship in selectedStrategy.relationships" :key="'relationship' + relationship.id">
                                  <td v-if="relationship.type === 'objective'">
                                    <div class="cont-icon-org-unit d-inline-block me-1">
                                      <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconObjective'"> <use xlink:href="@/assets/icons/icons.svg#objective"/> </svg> &nbsp;
                                      {{ $t("views.relationships.strategyObjective") }}
                                    </div>
                                  </td>
                                  <td v-if="relationship.type === 'project'">
                                    <div class="cont-icon-org-unit d-inline-block me-1">
                                      <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconProject'"> <use xlink:href="@/assets/icons/icons.svg#project"/> </svg> &nbsp;
                                      {{ $t("views.relationships.strategyProject") }}
                                    </div>
                                  </td>
                                  <td v-if="relationship.type === 'kpi'">
                                    <div class="cont-icon-org-unit d-inline-block me-1">
                                      <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconKpi'"> <use xlink:href="@/assets/icons/icons.svg#kpi"/> </svg> &nbsp;
                                      {{ $t("views.relationships.strategyKpi") }}
                                    </div>
                                  </td>
                                  <td v-if="relationship.type === 'objective'"> <a :href="createLink('objective', relationship.objectiveUuid)" target="_blank"> {{relationship.category === 1 ? relationship.name.toUpperCase() : relationship.name }} </a> </td>
                                  <td v-if="relationship.type === 'project'">   <a :href="createLink('project', relationship.projectUuid)" target="_blank"> {{ relationship.name }} </a> </td>
                                  <td v-if="relationship.type === 'kpi'">       <a :href="createLink('kpi', relationship.kpiUuid)" target="_blank"> {{ relationship.name }} </a> </td>
                                  <td>{{ formatDate(new Date(relationship.validFrom)) }}</td>
                                  <td>{{ formatDate(new Date(relationship.validTo)) }}</td>
                                  <td v-if="selectedStrategy.write" class="text-end">
                                    <div class="dropdown">
                                      <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                        <svg class="bi" width="28" height="28" fill="currentColor">
                                          <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                        </svg>
                                      </a>
                                      <ul class="dropdown-menu">
                                        <li><a @click="openModal(relationship.id, relationship.name, 'relationship', 'delete')" class="dropdown-item" href="#strategyDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-else class="mt-3 h6">{{ $t("views.relationships.noRelationships") }}</div>
                        </div>
                        <div class="tab-pane fade" id="trials" role="tabpanel">
                          <div v-if="selectedStrategy.write" class="row my-3">
                            <div class="col">
                              <button @click="openModal(false, '', 'trial', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#strategyEditModal">+ {{ $t("general.add") }}</button>
                            </div>
                          </div>
                          <div v-if="selectedStrategy.trials.length">
                            <table class="table">
                              <thead>
                                <tr class="border-dark">
                                  <th scope="col">{{ $t("views.strategy.detail.trialDescription") }}</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="trial in selectedStrategy.trials" :key="'trial' + trial.id">
                                  <th scope="row" class="fw-normal">{{ trial.description }}</th>
                                  <td v-if="selectedStrategy.write" class="text-end">
                                    <div class="dropdown">
                                      <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                        <svg class="bi" width="28" height="28" fill="currentColor">
                                          <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                        </svg>
                                      </a>
                                      <ul class="dropdown-menu">
                                        <li><a @click="generateFromTrial(trial, 'objective')" class="dropdown-item" href="#">{{ $t("views.strategy.detail.trialGenerateObjective") }}</a></li>
                                        <li><a @click="generateFromTrial(trial, 'project')" class="dropdown-item" href="#">{{ $t("views.strategy.detail.trialGenerateProject") }}</a></li>
                                        <li><a @click="generateFromTrial(trial, 'measure')" class="dropdown-item" href="#">{{ $t("views.strategy.detail.trialGenerateMeasure") }}</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a @click="openModal(trial.id, trial.description, 'trial', 'update')" class="dropdown-item" href="#strategyEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                        <li><a @click="openModal(trial.id, trial.description, 'trial', 'delete')" class="dropdown-item" href="#strategyDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-else class="mt-3 h6">{{ $t("views.strategy.detail.noTrials") }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-5">
          <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
          <p v-if="'nodes' in strategies && strategies.nodes.length" class="h5 mt-3">{{ $t("views.strategy.structure.helpChooseStrategy") }}</p>
          <p v-else class="h5 mt-3">{{ $t("views.strategy.structure.helpCreateStrategy") }}</p>
        </div>
        <StrategyEditModal></StrategyEditModal>
        <StrategyDeleteModal></StrategyDeleteModal>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import * as bootstrap from 'bootstrap'
import { i18n } from '../../i18n'
import router from '@/router'
import StrategyTree from '@/components/strategies/StrategyTree.vue'
import StrategyEditModal from '@/components/strategies/StrategyEditModal.vue'
import StrategyDeleteModal from '@/components/strategies/StrategyDeleteModal.vue'
import QuillContent from '@/components/QuillContent.vue'
import * as formatUtils from '@/composables/formatUtils'
import * as tree from '@/composables/tree'
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: 'StrategyManageStrategy',
  data () {
    return {
      strategyModalElementId: false,
      strategyModalElementType: '',
      strategyModalMode: '',
      selectedElement: '',
      filterValidFrom: this.$store.state.user?.settings?.favorites?.strategyManage?.filterValidFrom ? this.$store.state.user.settings.favorites.strategyManage.filterValidFrom : new Date().getFullYear().toString() + '-01-01',
      filterValidTo: this.$store.state.user?.settings?.favorites?.strategyManage?.filterValidTo ? this.$store.state.user.settings.favorites.strategyManage.filterValidTo : (new Date().getFullYear() + 1).toString() + '-12-31',
      searchText: '',
      autoOpenDepth: 2,
      sliderKey: 0
    }
  },
  components: {
    StrategyTree,
    StrategyEditModal,
    StrategyDeleteModal,
    QuillContent
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    strategies () {
      return this.$store.state.strategies.constructor === Array ? [] : this.$store.state.strategies
    },
    selectedStrategy () {
      return this.$store.state.selectedStrategy
    },
    selectedStrategyDescriptionFull () {
      const userLocale = this.$store.state.user.settings?.language
      let selectedStrategyDescriptionFull = this.selectedStrategy.description
      if (this.selectedStrategy.folder !== true) {
        if (this.selectedStrategy.benefit !== '<p><br></p>') {
          selectedStrategyDescriptionFull = selectedStrategyDescriptionFull + '<br><u>' + i18n?.global.t('general.benefit', userLocale) + '</u>' + this.selectedStrategy.benefit
        }
        if (this.selectedStrategy.risk !== '<p><br></p>') {
          selectedStrategyDescriptionFull = selectedStrategyDescriptionFull + '<br><u>' + i18n?.global.t('general.risk', userLocale) + '</u>' + this.selectedStrategy.risk
        }
      }
      return selectedStrategyDescriptionFull
    },

    // maximale Strukturtiefe ermitteln (Fallback 2)
    maxTreeDepth () {
      return tree.getMaxTreeDepth(this.$store.state.strategies?.nodes, 2)
    }
  },

  watch: {
    'strategies.nodes': {
      handler (nodes) {
        if (!nodes || nodes.length === 0) return

        // Set Slider Default-Level (Fallback = 2)
        const depth = this.maxTreeDepth
        const defaultLevel = this.sysParms?.strategyTreeDefaultLevel ?? 2
        this.autoOpenDepth = Math.min(Math.max(defaultLevel, 2), depth)

        // Render Slider
        this.sliderKey++
      },
      immediate: true
    }
  },

  methods: {
    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      return url
    },
    async filterStrategies (filterFrom, filterTo) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.filterValidFrom = filterFrom
      this.filterValidTo = filterTo
      await this.$store.dispatch('getStrategies', { validFrom: filterFrom, validTo: filterTo })
      await this.$store.dispatch('favoriteStrategy', { isList: false, objectKey: 'strategyManage', objectValue: { filterValidFrom: filterFrom, filterValidTo: filterTo } })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    openModal (id, name, elementType, mode) {
      if (id) {
        this.strategyModalElementId = id
      }
      if (name) {
        this.strategyModalElementName = name.replace(/<[^>]*>/g, '') // Convert name from html to plaintext
      }
      this.strategyModalElementType = elementType
      this.strategyModalMode = mode
    },
    async generateFromTrial (trial, type) {
      const elementData = {
        strategyId: this.selectedStrategy.id,
        type,
        name: trial.description
      }
      this.$store.commit('SET_LOADING_STATUS', true)
      if (type === 'objective') {
        this.$store.dispatch('strategyGenerateFromTrial', elementData)
        this.$store.dispatch('getObjectives', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })
        router.push({ name: 'ObjectivesManageObjective' })
      }
      if (type === 'project') {
        this.$store.dispatch('strategyGenerateFromTrial', elementData)
        this.$store.dispatch('getProjects', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })
        router.push({ name: 'ProjectsManageProject' })
      }
      if (type === 'measure') {
        nextTick(() => {
          const trigger = document.querySelector('[data-bs-target="#measures"]')
          const tab = bootstrap.Tab.getOrCreateInstance(trigger)
          this.openModal(false, trial.description, 'measure', 'addFromTrial')
          const modal = bootstrap.Modal.getOrCreateInstance('#strategyEditModal')
          wait(1000).then(() => {
            modal.show()
            tab.show()
          })
        })
      }

      this.$store.commit('SET_LOADING_STATUS', false)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)

    // check query params for selected strategy
    let paramSelectedStrategy = ''
    if (this.$route.query.id) {
      paramSelectedStrategy = this.$route.query.id
    }

    // get filter values from param object
    if (paramSelectedStrategy !== '') {
      await this.$store.dispatch('getStrategy', paramSelectedStrategy)
      this.searchText = this.selectedStrategy.name
      this.filterValidFrom = this.selectedStrategy.validFrom
      this.filterValidTo = this.selectedStrategy.validTo
    }

    await this.$store.dispatch('getStrategies', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })

    if (Object.keys(this.selectedStrategy).length) {
      await this.$store.dispatch('getStrategy', this.selectedStrategy.id)
    }
    await this.$store.dispatch('getOrgUnits', { validFrom: this.filterValidFrom, validTo: this.filterValidTo, view: 'org' })
    await this.$store.dispatch('getEmployees', { mode: 'default' })
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}
</style>
